import { ArrowLeftOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Card, Form, message } from 'antd';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MODULES, ROUTES } from '../../../../../common/constants';
import GoBackButton from '../../../../../components/GoBackButton';
import Portal from '../../../../../components/Portal';
import PaymentLinksForm from '../components/UserPayoutsLinksForm';
import { CREATE_PAYMENT_LINK } from '../graphql/Queries';

const CreateUserPayoutLink = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [planExpiryDate, setPlanExpiryDate] = useState(undefined);

  const [createPersonalizedOffer, { loading }] = useMutation(
    CREATE_PAYMENT_LINK,
    {
      onCompleted: () => {
        history.replace(`${ROUTES?.PAYMENTS}${ROUTES?.USER_PAYOUT_LINKS}`);
        message?.success('Payment link created successfully!');
      },
      onError: () => {},
    },
  );

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const { name } = values;
      const fullName = name?.trim();
      const parts = fullName?.split(' ');
      await createPersonalizedOffer({
        variables: {
          data: {
            expiredAt: values?.expiredAt?.toISOString(),
            metaData: {
              userDamageWaiverFeesApplied: values?.userDamageWaiverFeesApplied,
            },
            sellingPrice: parseFloat(values?.sellingPrice),
            subscriptionPlanId: values?.plan,
            contactNo: values?.contactNo,
            email: values?.email,
            notes: values?.notes,
            firstName: parts?.shift(),
            lastName: parts?.join(' '),
            planExpiryDate: planExpiryDate?.toISOString(),
          },
        },
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Error creating payment link:', e);
    }
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton
          customLink={`${ROUTES?.PAYMENTS}${ROUTES?.USER_PAYOUT_LINKS}`}
        />
        <div className="portal-header">{MODULES.PAYMENT_LINKS}</div>
      </Portal>
      <Portal portalId="header-right-content">
        <Button
          className="common-button"
          icon={<ArrowLeftOutlined />}
          onClick={() =>
            history.push(`${ROUTES?.PAYMENTS}${ROUTES?.USER_PAYOUT_LINKS}`)
          }
        >
          Cancel
        </Button>
        <Button
          className="common-button ml-16"
          onClick={handleSubmit}
          loading={loading}
        >
          Create
        </Button>
      </Portal>
      <Portal portalId="header-right-content-phones">
        <Button
          className="common-button"
          icon={<ArrowLeftOutlined />}
          onClick={() =>
            history.push(`${ROUTES?.PAYMENTS}${ROUTES?.USER_PAYOUT_LINKS}`)
          }
        >
          Cancel
        </Button>
        <Button
          type="primary"
          className="common-button ml-16"
          onClick={handleSubmit}
          loading={loading}
        >
          Create
        </Button>
      </Portal>
      <Card className="full-height-without-nav">
        <PaymentLinksForm
          form={form}
          setPlanExpiryDate={setPlanExpiryDate}
          planExpiryDate={planExpiryDate}
        />
      </Card>
    </>
  );
};

export default CreateUserPayoutLink;
